exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inclusion-box{border:1px solid var(--blue-light-3);background-color:var(--blue-light-1)}@media(max-width:600px){.inclusion-box{margin:-16px -24px;border:none}}", ""]);

// exports
